import React from 'react'

export function Switch({label, checked, onChange}: SwitchProps) {
  return (
    <div className='form-check form-switch form-check-custom form-check-solid me-10 my-1'>
      <input
        className='form-check-input h-20px w-35px'
        type='checkbox'
        checked={checked}
        onChange={onChange}
        readOnly={!onChange}
      />
      <label className='form-check-label'>{label}</label>
    </div>
  )
}

interface SwitchProps {
  label: string | React.ReactNode
  checked: boolean
  onChange: () => void
}
